import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { FormBehaviorPlanService } from "../../../../Services/FormBehaviorPlanService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IFormBehaviorPlan } from "../../../../Models/Forms/IFormBehaviorPlan";
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'BehaviorPlan',
  templateUrl: './BehaviorPlan.component.html',
  styleUrls: ['./BehaviorPlan.component.css']
})

export class FormBehaviorPlanComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;  
  canEditIep: boolean;
  saveClicked: boolean;
  behaviorPlanDB: IFormBehaviorPlan;
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals,
    private _formBehaviorPlanService: FormBehaviorPlanService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string, reportService: ReportService,
    public router: Router) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this.behaviorPlanDB = {} as IFormBehaviorPlan;
  }

  ngOnInit(): void {
    this.LoadFormBehaviorPlanDetails();
    //this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  severityClick(severityOption) {
    if (severityOption == 'Extreme') {
      this.behaviorPlanDB.interferingSeveritySerious = false
      this.behaviorPlanDB.interferingSeverityModerate = false
      this.behaviorPlanDB.interferingSeverityNeedingAttention = false
    }
    else if (severityOption == 'Serious') {
      this.behaviorPlanDB.interferingSeverityExtreme = false
      this.behaviorPlanDB.interferingSeverityModerate = false
      this.behaviorPlanDB.interferingSeverityNeedingAttention = false
    }
    else if (severityOption == 'Moderate') {
      this.behaviorPlanDB.interferingSeverityExtreme = false
      this.behaviorPlanDB.interferingSeveritySerious = false
      this.behaviorPlanDB.interferingSeverityNeedingAttention = false
    }
    else if (severityOption == 'Needing attention') {
      this.behaviorPlanDB.interferingSeverityExtreme = false
      this.behaviorPlanDB.interferingSeveritySerious = false
      this.behaviorPlanDB.interferingSeverityModerate = false
    }
  }

  updateRadioButtonTwoOptions() {
    if (this.behaviorPlanDB.interventionsAchieveBothYes == true) {
      this.behaviorPlanDB.interventionsAchieveBothNo = false
    }
    else {
      this.behaviorPlanDB.interventionsAchieveBothNo = true
    }

    if (this.behaviorPlanDB.interventionsReinforcementAloneYes == true) {
      this.behaviorPlanDB.interventionsReinforcementAloneNo = false
    }
    else {
      this.behaviorPlanDB.interventionsReinforcementAloneNo = true
    }

    if (this.behaviorPlanDB.interventionsEnvironmentalSupportsYes == true) {
      this.behaviorPlanDB.interventionsEnvironmentalSupportsNo = false
    }
    else {
      this.behaviorPlanDB.interventionsEnvironmentalSupportsNo = true
    }

    if (this.behaviorPlanDB.interventionsCurriculumAccomodationsYes == true) {
      this.behaviorPlanDB.interventionsCurriculumAccomodationsNo = false
    }
    else {
      this.behaviorPlanDB.interventionsCurriculumAccomodationsNo = true
    }

    if (this.behaviorPlanDB.interventionsCurriculumAccomodationsPlanYes == true) {
      this.behaviorPlanDB.interventionsCurriculumAccomodationsPlanNo = false
    }
    else {
      this.behaviorPlanDB.interventionsCurriculumAccomodationsPlanNo = true
    }

    if (this.behaviorPlanDB.communicationProvisionsDaily == true) {
      this.behaviorPlanDB.communicationProvisionsWeekly = false
    }
    else {
      this.behaviorPlanDB.communicationProvisionsWeekly = true
    }

    if (this.behaviorPlanDB.communicationProvisionsReporting == true) {
      this.behaviorPlanDB.communicationProvisionsRecordKeeping = false
    }
    else {
      this.behaviorPlanDB.communicationProvisionsRecordKeeping = true
    }
  }

  loadUnLock() {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=UnLock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  LoadFormBehaviorPlanDetails(): void {
    this._formBehaviorPlanService.getFormBehaviorPlan(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormBehaviorPlan) => {
        this.behaviorPlanDB = res,
          this.behaviorPlanDB.date = new Date(this.behaviorPlanDB.date);
      },
        err => console.error(err)
      );
  }

  //current severity of behavior problem
  //LoadLookupValues() {
  //}

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the BehaviorPlan
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.updateRadioButtonTwoOptions();

    this.behaviorPlanDB.iepId = this.selectedIepInstance.iepId;

    //update values    
    this._formBehaviorPlanService.insertUpdateFormBehaviorPlan(this.behaviorPlanDB)
      .subscribe((res: IFormBehaviorPlan) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock();
        }
        this.saveClicked = false;
        this.validateForm();
        this.LoadFormBehaviorPlanDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formBehaviorPlanService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock();
    //this.router.navigate(['iep-ap']);
    this.LoadFormBehaviorPlanDetails();
  }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.behaviorPlanDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.behaviorPlanDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this.selectedIepInstance.statusName == 'Draft' ? 'True' : 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: this.selectedIepInstance.statusName == 'Draft' ? 'Draft Draft Draft' : '' },
      { parameterName: 'BlankForm', parameterValue: 'false' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.behaviorPlanDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.behaviorPlanDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
